import {
  ICaseBattle,
  ICaseBattleRound,
} from '../interfaces/case-battles.interface';

export const getTeamModeSumBySlot = (battle: ICaseBattle, slot: number) => {
  const teamOneSlots = [1, 2];
  const teamSecondSlots = [3, 4];
  const isTeamOne = teamOneSlots.includes(slot);

  return (
    battle.rounds.reduce((acc, curr) => {
      const currSlot = curr.drops.filter((item) =>
        isTeamOne
          ? teamOneSlots.includes(item.user.slot)
          : teamSecondSlots.includes(item.user.slot)
      );
      return acc + currSlot.reduce((slotAcc, drop) => slotAcc + drop.price, 0);
    }, 0) / 2
  );
};

export const getRegularModeSumBySlot = (battle: ICaseBattle, slot: number) => {
  const sum =
    battle.rounds.reduce((acc, curr) => {
      const currSlot = curr.drops.find((item) => item.user.slot === slot);
      return acc + (currSlot?.price ?? 0);
    }, 0) ?? 0;

  return sum;
};

export const getDropsSumByBattle = (battle: ICaseBattle) => {
  return battle.rounds
    .map((round) => round.drops.reduce((acc, curr) => acc + curr.price, 0))
    .reduce((acc, curr) => acc + curr, 0);
};

export const getEquityModeSum = (battle: ICaseBattle) => {
  const sum =
    battle.rounds.reduce((acc, curr) => {
      const currSlot = curr.drops.reduce((acc, drop) => {
        return acc + drop.price;
      }, 0);
      return acc + currSlot;
    }, 0) ?? 0;

  return sum / battle.max_participants;
};

export const getUserRoundsBySlot = (
  rounds: ICaseBattleRound[],
  slot: number
) => {
  const result = rounds.flatMap((round) =>
    round.drops.filter((user) => user.user.slot === slot)
  );
  return result;
};

export const getUserDropsCostBySlot = (
  rounds: ICaseBattleRound[],
  slot: number
) => {
  return getUserRoundsBySlot(rounds, slot).reduce(
    (acc, curr) => acc + curr.price,
    0
  );
};
